<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryItems, activeIndex } = useUiMediaGallery(props.name)

function prev() {
  let prev = activeIndex.value - 1
  if (prev < 0) {
    prev = galleryItems.value.length - 1
  }
  activeIndex.value = prev
}

function next() {
  let next = activeIndex.value + 1
  if (next >= galleryItems.value.length) {
    next = 0
  }
  activeIndex.value = next
}
</script>

<template>
  <div class="media-gallery-navigation">
    <button
      type="button"
      class="media-gallery-navigation__prev"
      :disabled="activeIndex === 0"
      @click="prev"
    >
      <slot name="gallery-prev-icon">
        <NuxtIcon
          name="icon:arrow"
          class="icon:arrow-prev"
        />
      </slot>
    </button>

    <button
      type="button"
      class="media-gallery-navigation__next"
      :disabled="activeIndex === (galleryItems?.length || 0) - 1"
      @click="next"
    >
      <slot name="gallery-next-icon">
        <NuxtIcon name="icon:arrow" />
      </slot>
    </button>
  </div>
</template>

<style>
@import url("~layers/components/Ui/MediaGallery/Navigation.css");
</style>
